<template>
  <div>
    <div class="filters-container">
      <div class="content-filter">
        <div class="filter-search">
          <label>Title:</label>
          <input type="text" class="search-text-box" autocomplete="off" v-model="searchText" placeholder="Enter Search" @keypress.enter="searchData" @blur="searchTextError = false">
          <button class="search-btn" @click="searchData" @blur="searchTextError = false">Search</button>
          <button class="clear-btn" v-if="showClearOption && !searchTextError && this.searchText != ''" @click="clearSearch">Clear Search</button>
          <p v-if="searchTextError">{{ searchErrorMsg }}</p>
        </div>
        <div class="filter-type">
          <form autocomplete="off">
            <label>Content Type</label>
            <select v-model="selectedContentType" autocomplete="off">
              <option v-for="(value, propertyName, index) in contentType" :key="index" :value="value">{{ propertyName }}</option>
            </select>
            <button class="clear-btn" v-if="showClearFilter" @click="clearFilter">Clear Filter</button>
          </form>
        </div>
        <div class="filter-lang">
          <form autocomplete="off">
            <label>Language</label>
            <select v-model="selectedLanguage">
              <option v-for="(data,index) in language" :key="index" :value="data">{{ data }}</option>
            </select>
          </form>
        </div>
        <div class="filter-btn">
          <button @click="getTableData('filter')">Filter</button>
        </div>
      </div>
      <div class="content-action">
        <div class="filter-lang">
          <form autocomplete="off">
            <label>Actions</label>
            <select v-model="selectedAction" autocomplete="off">
              <option value="publish">Publish</option>
              <option value="makeitpublishable">Make it publishable for all languages</option>
              <option value="unpublish">Make it unpublishable for all languages</option>
            </select>
          </form>
        </div>
        <div class="filter-btn">
          <button :disabled="selectedItem.length === 0" @click="actionItems">Apply to selected item</button>
        </div>
      </div>
    </div>
    <div class="content-table-container">
      <table aria-describedby="Press release and Article list">
        <thead>
          <th id="selection-box"/>
          <th id="Date">
            Date
            <label class="arrow-down" @click="sortData('dateasc')" v-if="!sortDate"/>
            <label class="arrow-up" @click="sortData('datedes')" v-else/>
          </th>
          <th id="Title">
            Title
            <label class="arrow-down" @click="sortData('titleasc')" v-if="!sortTitle"/>
            <label class="arrow-up" @click="sortData('titledes')" v-else/>
          </th>
          <th id="Lang">
            Lang
          </th>
          <th id="Type">
            Type
          </th>
          <th id="Author">
            Author
          </th>
          <th id="Actions"/>
        </thead>
        <tbody v-if="tableData !== null && tableData.length > 0">
          <tr v-for="(data,index) in tableData" :key="index">
            <td>
              <input class="styled-checkbox" :id="index" type="checkbox" :value="data.ItemID" v-model="selectedItem">
              <label :for="index"/>
            </td>
            <td>{{ data.PublicationDate }}</td>
            <td>{{ data.Title === '' ? data.ItemName : data.Title }}</td>
            <td>{{ data.Language }}</td>
            <td>{{ data.ItemType }}</td>
            <td>{{ data.CreatedBy }}</td>
            <td>
              <button class="action--btn edit-btn" @click="editItem(data)">Edit</button>
              <a :href="data.PreviewUrl" target="_blank" class="action--btn edit-btn">Preview</a>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" style="text-align:center">No Result found</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="content-pagination" v-if="pageCount > 1">
      <button @click="previousPage" :disabled="paginationValue === 1" class="pagination-label">Previous Page</button>
      <form autocomplete="off" class="pagination--form">
        <select v-model="paginationValue" @change="getTableData('pageSelect')" autocomplete="off">
          <option v-for="n of pageCount" :key="n" :value="n">{{ n }}</option>
        </select>
      </form>
      <button @click="nextPage" :disabled="paginationValue === pageCount" class="pagination-label">Next Page</button>
    </div>
    <api-loader :is-loading="isLoading" />
    <bo-Notification ref="notification" />
  </div>
</template>
<script>
  import ApiLoader from '../ApiLoader/api-loader';
  import { fetchData } from '@Foundation/services';
  import BoNotification from '../BoNotification/bo-notification';
  export default {
    name: 'bo-content',
    components: {
      ApiLoader,
      BoNotification
    },
    props: {
      dataJson: {
        type: Object,
        required: false,
        default: null
      }
    },
    data() {
      return {
        isLoading: false,
        showAlertModal: false,
        tableData: [],
        contentType: null,
        language: null,
        pageCount: 0,
        paginationValue: 1,
        selectedItem: [],
        selectedContentType: '',
        selectedLanguage: '',
        searchText: '',
        selectedAction: 'publish',
        itemToDelete: [],
        searchTextError: false,
        searchErrorMsg: 'Please enter atleast 3 character',
        showClearOption: false,
        sortDate: false,
        sortTitle: false,
        showClearFilter: false,
        latestSortValue: 'datedes'
      };
    },
    mounted() {
      this.tableData = this.dataJson.ResultData;
      this.contentType = this.dataJson.contentFilter;
      this.language = this.dataJson.Languages;
      this.pageCount = this.dataJson.PageCount;
      this.selectedLanguage = 'en',
      this.selectedContentType = '{56860ED0-5421-4C80-AED8-5359BA4DADBD}|{5FF5E747-246B-471C-B201-E032F6F5C316}';
    },
    methods: {
      actionItems() {
        this.isLoading = true;
        const obj = {
          ItemIds: this.selectedItem,
          RequestAction: this.selectedAction
        };
        fetchData(`/Content-News-PR/ProcessActionItem`, { data: obj }).then((response)=>{
          this.isLoading = false;
          if (response.IsActionSuccess) {
            this.selectedItem = [];
            if (this.selectedAction === 'publish') {
              this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Item Published Successfully' : response.ResponseMessage,true);
            } else if (this.selectedAction === 'makeitpublishable') {
              this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Item Make Publishable Successfully' : response.ResponseMessage,true);
            } else {
              this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Item Make UnPublishable Successfully' : response.ResponseMessage,true);
            }
          } else {
            this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Failed' : response.ResponseMessage,false);
          }
        }).catch((response)=>{
          this.$refs.notification.showNotification(true,response.ResponseMessage === null ? 'Failed' : response.ResponseMessage,false);
        });
      },

      nextPage() {
        this.paginationValue = this.paginationValue + 1;
        this.getTableData('nextPage');
      },

      previousPage() {
        this.paginationValue = this.paginationValue - 1;
        this.getTableData('previousPage');
      },

      getTableData(type) {
        this.isLoading = true;
        this.selectedItem = [];
        let url;
        if (!this.showClearOption || this.searchText.length < 3) {
          url = `/Content-News-PR/GetfilteredNewsPr?page=${this.paginationValue}&language=${this.selectedLanguage}&contentFilter=${this.selectedContentType}&country=global&sortby=${this.latestSortValue}`;
        } else {
          url = `/Content-News-PR/GetfilteredNewsPr?page=${this.paginationValue}&language=${this.selectedLanguage}&contentFilter=${this.selectedContentType}&country=global&q=${this.searchText}&sortby=${this.latestSortValue}`;
        }
        if (type === 'filter') {
          this.showClearFilter = true;
        }
        fetchData(url).then((res)=>{
          this.isLoading = false;
          if (!res.IsNoResult) {
            this.tableData = res.ResultData;
            this.pageCount = res.PageCount;
            if (type === 'clear' || type === 'filter') {
              this.paginationValue = 1;
            }
          } else {
            this.tableData = [];
            this.pageCount = res.PageCount;
          }
        });
      },

      searchData() {
        if (this.searchText === '') {
          this.searchTextError = true;
        } else if (this.searchText.length < 3) {
          this.searchTextError = true;
          this.searchErrorMsg = 'Enter 3 or more characters';
        } else {
          if (this.searchText.indexOf('>') > -1 ||  this.searchText.indexOf('<') > -1 ||  this.searchText.indexOf('%') > -1) {
            this.searchTextError = true;
            this.searchErrorMsg = 'invalid text';
          } else {
            this.searchTextError = false;
            this.showClearOption = true;
            this.isLoading = true;
            fetchData(`/Content-News-PR/GetfilteredNewsPr?language=${this.selectedLanguage}&contentFilter=${this.selectedContentType}&country=global&q=${this.searchText}`).then((res)=>{
              this.isLoading = false;
              if (!res.IsNoResult) {
                this.tableData = res.ResultData;
                this.pageCount = res.PageCount;
                this.paginationValue = 1;
              } else {
                this.tableData = [];
                this.pageCount = res.PageCount;
              }
            });
          }
        }
      },

      sortData(val) {
        this.latestSortValue = val;
        if (val.indexOf('date') > -1) {
          this.sortDate = !this.sortDate;
        }
        if (val.indexOf('title') > -1) {
          this.sortTitle = !this.sortTitle;
        }
        this.isLoading = true;
        fetchData(`/Content-News-PR/GetfilteredNewsPr?language=${this.selectedLanguage}&contentFilter=${this.selectedContentType}&country=global&sortby=${val}`).then((response)=>{
          this.isLoading = false;
          if (!response.IsNoResult) {
            this.tableData = response.ResultData;
            this.pageCount = response.PageCount;
            this.paginationValue = 1;
          } else {
            this.tableData = [];
            this.paginationValue = 1;
          }
        });
      },

      editItem(data) {
        if (data.ItemType === 'News') {
          window.location.href = `/Content-News-PR/Create-News/?ItemId=${data.ItemID}&Language=${data.Language}`;
        } else {
          window.location.href = `/Content-News-PR/Create-Press-Release/?ItemId=${data.ItemID}&Language=${data.Language}`;
        }
      },

      clearSearch() {
        this.showClearOption = false;
        this.searchText = '';
        this.getTableData('clear');
      },

      clearFilter() {
        this.selectedContentType = '{56860ED0-5421-4C80-AED8-5359BA4DADBD}|{5FF5E747-246B-471C-B201-E032F6F5C316}',
        this.selectedLanguage = 'en',
        this.showClearFilter = false;
        this.getTableData('clear');
      }
    }
  };
</script>
<style lang="scss" src="./bo-content.scss"></style>
